var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_27_82",
    "data-name": "Component 27 \\u2013 82",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-right",
    "data-name": "Icon awesome-arrow-right",
    d: "M5.1,3.431,5.7,2.836a.64.64,0,0,1,.908,0l5.207,5.2a.64.64,0,0,1,0,.908L6.6,14.154a.64.64,0,0,1-.908,0L5.1,13.56a.644.644,0,0,1,.011-.919L8.34,9.567H.643A.641.641,0,0,1,0,8.924V8.067a.641.641,0,0,1,.643-.643h7.7L5.113,4.349A.639.639,0,0,1,5.1,3.431Z",
    transform: "translate(6 3.353)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.24062689764fca9dedfff15c071232e0.svg";
export { ForwardRef as ReactComponent };